export default "__VITE_ASSET__DIJi_6QJ__"